module.exports = __webpack_public_path__ + "img/daedal-logo-dark.7d43ac23.png";